import React, { useState, useEffect } from 'react';
import './TermsOfUse.scss';

const TermsOfUse = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [activeSection, setActiveSection] = useState('introduction');

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.pageYOffset > 300);
      
      // Mise à jour de la section active en fonction du défilement
      const sections = document.querySelectorAll('h2');
      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        if (window.scrollY >= sectionTop - 100) {
          setActiveSection(section.id);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="terms-of-use">
      <header className="header">
        <div className="container header-content">
          <div className="logo">
            <div className="logo-icon">📄</div>
            <div className="logo-text">Termes d'Utilisation</div>
          </div>
        </div>
      </header>

      <nav className="navigation">
        <div className="container nav-container">
          <ul className="nav-links">
            <li>
              <a 
                href="#introduction" 
                className={activeSection === 'introduction' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('introduction');
                }}
              >
                Introduction
              </a>
            </li>
            <li>
              <a 
                href="#compte" 
                className={activeSection === 'compte' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('compte');
                }}
              >
                Compte
              </a>
            </li>
            <li>
              <a 
                href="#utilisation" 
                className={activeSection === 'utilisation' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('utilisation');
                }}
              >
                Utilisation
              </a>
            </li>
            <li>
              <a 
                href="#propriete" 
                className={activeSection === 'propriete' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('propriete');
                }}
              >
                Propriété
              </a>
            </li>
            <li>
              <a 
                href="#responsabilite" 
                className={activeSection === 'responsabilite' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('responsabilite');
                }}
              >
                Responsabilité
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <main className="container main-content">
        <div className="terms-content">
          <h1 id="introduction">Termes d'Utilisation - Connexion via Facebook</h1>
          
          <p className="last-updated">Dernière mise à jour: 10 novembre 2023</p>
          
          <div className="acceptance-box">
            <p>En accédant ou en utilisant notre application avec connexion Facebook, vous acceptez d'être lié par les présentes conditions d'utilisation.</p>
          </div>
          
          <h2 id="compte">1. Création et gestion de compte</h2>
          <p>Pour utiliser notre application, vous devez vous connecter via Facebook. En vous connectant, vous nous autorisez à accéder à certaines informations de votre profil Facebook conformément à nos paramètres de confidentialité.</p>
          
          <h3>1.1. Exigences du compte</h3>
          <p>Vous devez :</p>
          <ul>
            <li>Disposer d'un compte Facebook valide et actif</li>
            <li>Fournir des informations exactes et à jour</li>
            <li>Maintenir la sécurité de vos identifiants de connexion</li>
            <li>Être âgé d'au moins 13 ans (ou l'âge minimum requis dans votre pays)</li>
          </ul>
          
          <h3>1.2. Suspension et résiliation</h3>
          <p>Nous nous réservons le droit de suspendre ou de résilier votre compte en cas de violation des présentes conditions d'utilisation.</p>
          
          <h2 id="utilisation">2. Conditions d'utilisation</h2>
          <p>En utilisant notre application, vous vous engagez à :</p>
          <ul>
            <li>Respecter toutes les lois et réglementations applicables</li>
            <li>Ne pas utiliser l'application à des fins illégales ou non autorisées</li>
            <li>Ne pas transmettre de contenu malveillant ou nuisible</li>
            <li>Ne pas tenter d'accéder de manière non autorisée à des parties restreintes de l'application</li>
            <li>Ne pas perturber ou surcharger nos infrastructures</li>
          </ul>
          
          <div className="warning-box">
            <p>Toute violation de ces conditions peut entraîner la suspension immédiate de votre accès à l'application.</p>
          </div>
          
          <h2 id="propriete">3. Propriété intellectuelle</h2>
          <p>Notre application et son contenu original, ses fonctionnalités et sa conception sont la propriété exclusive de [Nom de votre entreprise] et sont protégés par les lois internationales sur le droit d'auteur, les marques commerciales, les brevets et autres lois sur la propriété intellectuelle.</p>
          
          <h3>3.1. Licence d'utilisation</h3>
          <p>Nous vous accordons une licence limitée, non exclusive, non transférable et révocable pour utiliser notre application conformément aux présentes conditions.</p>
          
          <h3>3.2. Contenu utilisateur</h3>
          <p>En publiant du contenu dans notre application, vous nous accordez une licence mondiale, non exclusive, redevable de redevances pour utiliser, reproduire, modifier et afficher ce contenu.</p>
          
          <h2 id="responsabilite">4. Limitations de responsabilité</h2>
          <p>En aucun cas [Nom de votre entreprise] ni ses dirigeants, employés ou partenaires ne pourront être tenus responsables des dommages indirects, accessoires, spéciaux ou consécutifs résultant de :</p>
          <ul>
            <li>Votre utilisation ou incapacité à utiliser l'application</li>
            <li>Tout accès non autorisé à vos données ou à leur utilisation</li>
            <li>Toute interruption ou cessation de transmission vers ou depuis notre application</li>
            <li>Tout bug, virus ou autre élément malveillant</li>
          </ul>
          
          <h2>5. Modifications des conditions</h2>
          <p>Nous nous réservons le droit, à notre seule discrétion, de modifier ou de remplacer ces conditions à tout moment. En cas de modification importante, nous vous en informerons par le biais de l'application ou par e-mail.</p>
          
          <h2>6. Loi applicable</h2>
          <p>Les présentes conditions sont régies et interprétées conformément aux lois françaises, sans égard aux principes de conflits de lois.</p>
          
          <h2>7. Nous contacter</h2>
          <p>Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter à :</p>
          <ul>
            <li>Email: legal@example.com</li>
            <li>Adresse: 123 Rue de la Legal, Paris, France</li>
          </ul>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Notre application</h3>
              <ul className="footer-links">
                <li><a href="#">À propos de nous</a></li>
                <li><a href="#">Fonctionnalités</a></li>
                <li><a href="#">Tarifs</a></li>
                <li><a href="#">Blog</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h3>Légal</h3>
              <ul className="footer-links">
                <li><a href="#">Politique de confidentialité</a></li>
                <li><a href="#" className="active">Conditions d'utilisation</a></li>
                <li><a href="#">Politique des cookies</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h3>Support</h3>
              <ul className="footer-links">
                <li><a href="#">Centre d'aide</a></li>
                <li><a href="#">Contact</a></li>
                <li><a href="#">FAQ</a></li>
              </ul>
            </div>
          </div>
          
          <div className="copyright">
            <p>&copy; 2023 Notre Application. Tous droits réservés.</p>
          </div>
        </div>
      </footer>

      <a 
        href="#" 
        className={`back-to-top ${showBackToTop ? 'show' : ''}`}
        onClick={scrollToTop}
      >
        ↑
      </a>
    </div>
  );
};

export default TermsOfUse;